<template>
  <div class="page-accounting-action">
    <header-page
			actions
			name="page-accounting-action"
			:title="$route.meta.title"
			@run-action="runAction"
			:button-close="openMobile"
			tabindex="-1"
			@click-close="closeMobile"
    />
	<backButtonRoute/>
	<v-dialog
	content-class="dialog-loading"
	max-width="300"
    persistent
	v-model="dialogLoading">
		<label class="loading-search">
			Espere unos segundos porfavor
		</label>
		<v-progress-linear
			indeterminate
			color="white"
			class="mb-0"
		></v-progress-linear>
	</v-dialog>
	<div class="pt-3 px-4 show-mobile">
		<v-layout row align-center wrap>
			<v-flex xs4 md2  pl-2 lg2>
				<BaseSelect
					class="select-accouting"
					label="Módulos"
					item-text="name"
					item-value="code"
					:height="32"
					v-model="model.moduleId"
					:items="modulesFilter"
					:value="model.moduleId"
					@input="setModule"
				/>
			</v-flex>
			<v-flex xs4 md2  pl-2 lg2>
			<BaseSelect
					:disabled="!model.moduleId"
					class="select-accouting"
					label="Estado de registros"
					item-text="name"
					item-value="id"
					:height="32"
					v-model="model.accountingSeat"
					:items="statusRecords"
					:value="model.accountingSeat"
					@input="setStatusRecords"
				/>
			</v-flex>
			<v-flex xs4 md2 pl-2 lg2>
				<BaseSelect
				class="select-accouting"
					item-text="name"
					item-value="id"
					label="Fechas"
					:height="32"
					:items="typesDate"
					@input="getDataDate($event)"
				/>
			</v-flex>
			<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
				<span class="captionDate">Fecha Desde</span>
						<date-component
							round
							:date="model.startDate"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'startDate', value: $event })"
						></date-component>
			</v-flex>
			<v-flex xs4 md2 pl-2 lg2 v-if="flagDate">
				<span class="captionDate">Fecha hasta</span>
						<date-component
							round
							:date="model.endDate"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'endDate', value: $event })"
						></date-component>
			</v-flex>
			<v-flex xs3 sm9 lg2 xs12>
				<v-layout row>
					<v-flex ml-3>
						<v-btn
							:disabled="!model.moduleId || flagStateRecord"
							color="blue"
							class="ma-0 btn-accounting mt-3"
							@click="loadCont">
							Buscar
						</v-btn>
					</v-flex>
					<v-flex ml-2>
						<v-btn
							color="error"
							class="ma-0 mt-3 btn-accounting"
							@click="clearAccouting"
						>
							Limpiar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 v-if="showAccouting">
				<v-btn
					:disabled="openMobile"
					color="blue"
					class="ma-0 btn-accounting mt-3 desktop"
					@click="openMobileAccouting"
				>
					Ver Asientos Contable
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row justify-end wrap mx-4>

		<v-flex xs2>
			<BaseSelect
					:disabled="!model.moduleId"
					class="select-accouting"
					label="Estado de asientos"
					item-text="name"
					item-value="id"
					:height="38"
					v-model="model.status"
					:items="status"
					:value="model.status"
					@input="setStatus"
				/>
		</v-flex>
		<v-flex xs2 sm2 md2 px-2>
			<BaseSelect
					:disabled="!model.moduleId"
					class="select-accouting"
					label="Tipo de Asientos"
					item-text="name"
					item-value="id"
					:height="38"
					v-model="model.square"
					:items="typesModule"
					:value="model.square"
					@input="setTypes"
				/>
		</v-flex>
		<v-flex
				xs4 sm2 md2 px-2 pt-2
			>
				<v-btn
				:disabled="disabledConfirm || flagNoConfirm"
				color="#2196f3"
				class="btnSaveAccounting"
				@click="saveAccouting"
				>
				Confirmar Asiento
					<v-icon dark>
						check_circle
					</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
	<div class="row-mobile">
		<v-layout row wrap mt-4>
			<v-flex xs12 sm12 lg6 px-2
			v-if="listAccounting && !openMobile">
				<app-table
					:check-all="checkAll"
					:columns="columns"
					:rows="rows"
					flag-title
					:items-total-quantity="itemsTotalQuantity"
					:items-quantity="rows.length"
					:last-page="lastPage"
					:title="titleModule"
					:input-search="false"
					:current-page="currentPage"
					:created-add="false"
					selectable
					@on-search-event="onSearch"
					@row-is-selected="rowIsSelected"
					@on-selected-all="selectedAll"
					@on-page="changePage"
				>
					<template slot="rows" slot-scope="props">
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columns, 1)">{{props.row.createdAt |  exactDate }}</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columns, 2)" class="entity">
							<p class="mb-0">
								<span class="desktop">Numero de documento: </span>
								<span v-if="props.row.documentNumberComplete && !mobile">
									<span v-if="props.row.documentNumberComplete.length < 17">{{props.row.transactionId || props.row.documentNumberComplete || props.row.documentAccountStatusId || props.row.code || props.row.gloss || props.row.documentNumber }}</span>
									<v-tooltip top v-else>
										<span slot="activator">{{props.row.id || props.row.documentNumberComplete || props.row.documentAccountStatusId || props.row.code || props.row.gloss || props.row.documentNumber}}</span>
										<span>{{props.row.transactionId || props.row.documentNumberComplete || props.row.documentAccountStatusId || props.row.code || props.row.gloss || props.row.documentNumber }}</span>
									</v-tooltip>
								</span>
								<span v-else>
									{{ props.row.id || props.row.documentNumberComplete || props.row.documentAccountStatusId || props.row.code || props.row.gloss || props.row.documentNumber }}
								</span>
							</p>
						</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columns, 3)">{{props.row.documents != null ? props.row.documents.toString() : props.row.observations || props.row.documentNumber || props.row.sendKardexMessage || props.row.gloss }}</td>
						<td style="height: 50px; font-size: 13px; color: #02979b; font-weight: bold;" v-show="showRow(columns, 4)">{{props.row.amount || props.row.totalDebe}}</td>
					</template>
				</app-table>
			</v-flex>
			<v-flex xs12 sm12 lg6 px-2
			class="content-acc"
			:class="{ 'open': openMobile }">
				<app-table
					:created-add="false"
					:check-all="checkAllAccounting"
					:columns="columnsSeat"
					:rows="rowsSeat"
					:items-total-quantity="itemsTotalQuantityDetails"
					:items-quantity="rowsSeat.length"
					selectable
					delete-seat
					:tooltip-delete="deleteTooltip"
					show-accounting
					flag-title
					:title="titleModuleSeat"
					:current-page="currentPageDetail"
					:input-search="false"
					:disabled-edit-accou="!rowsSeat.length > 0"
					:show-table-accounting="showDetailAccounting"
					:rows-details="rowsDetails"
					:last-page="lastPageDetails"
					@delete-seat="runAction('delete-seat')"
					@on-selected-all="selectedAllSeat"
					@on-page="onPage"
					@row-is-selected="rowIsSelectedAccounting"
					@edit-accouting="goToEditAccouting"
				>
					<template slot="rows" slot-scope="props">
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columnsSeat, 1)">{{props.row.code}}</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columnsSeat, 2)" class="gloss">
							<p class="mb-0">
								<span class="desktop">Descripción:</span>
								<span v-if="props.row.gloss && !mobile">
									<span v-if="props.row.gloss.length < 17">{{ props.row.gloss }}</span>
									<v-tooltip top v-else>
										<span slot="activator">{{ props.row.gloss | limitTo(17) }}</span>
										<span>{{ props.row.gloss }}</span>
									</v-tooltip>
								</span>
								<span v-else>
									{{props.row.gloss}}
								</span>
							</p>
						</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columnsSeat, 3)">{{props.row.date | exactDate}}</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columnsSeat, 4)">
							<app-tooltip-button
								:color="statusColor(props.row)"
								icon="radio_button_checked"
								:text="statusName(props.row)"
							/>
						</td>
						<td style="height: 50px; font-size: 13px;"  v-show="showRow(columnsSeat, 5)" class="blue-debe">{{props.row.totalDebe}}</td>
						<td style="height: 50px; font-size: 13px;"  v-show="showRow(columnsSeat, 6)" class="red-haber">{{props.row.totalHaber}}</td>
						<td style="height: 50px; font-size: 13px;" v-show="showRow(columnsSeat, 7)">
							<app-tooltip-button
								color="blue"
								icon='remove_red_eye'
								text="Ver Detalle"
								:width="17"
								@click-icon="openDetail(props.row)"
							/>
						</td>
					</template>
				</app-table>
			</v-flex>
		</v-layout>
		<v-dialog
			v-model="dialogDetailAccounting"
			max-width="750"
		>
			<v-card>
				<v-layout pa-3>
					<v-flex>{{nameAccouting}}</v-flex>
					<v-flex text-xs-right>
						<button @click="closeDialog">X</button>
					</v-flex>
				</v-layout>
				<v-divider></v-divider>
				<div class="pa-3">
					<app-table
						:rows="rowsDetailModal"
						:columns="columnsDetail"
						:input-search="false"
						:created-add="false"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columnsDetail, 1)">
								<template v-if="props.row.edit">
										<autocomplete-component
											append-icon="expand_more"
											class="edit-inline"
											http-code="$http"
											id="focus-edit-inline"
											:item="props.row.accountingAccount"
											item-text="fullName"
											item-value="id"
											:items="accounts"
											autocomplete
											model="accountingAccount"
											placeholder-value="Buscar cuenta contable"
											placeholder-input="Nombre de la cuenta"
											prop="account"
											prop-search="fullName"
											return-object
											select-create
											tabindex="1"
											@return-data="changeAccount({
												row: props.row,
												value: $event,
												index: props.index,
											})"
										></autocomplete-component>
									</template>
									<template v-else>
										<div>
											<span>{{props.row.accountingAccount.account }}</span>
										</div>
									</template>
								</td>
							<td v-show="showRow(columnsDetail, 2)">{{props.row.accountingAccount ? props.row.accountingAccount.name : null}}</td>
							<td v-show="showRow(columnsDetail, 3)" class="reference">
								<p class="mb-0">
									<span class="desktop">Referencia: {{props.row.reference}}</span>
									<span v-if="props.row.reference && !mobile">
										<span>{{props.row.reference}}</span>
									</span>
								</p>
							</td>
							<td v-show="showRow(columnsDetail, 4)">{{props.row.concept}}</td>
							<td v-show="showRow(columnsDetail, 5)">{{ getType(props.row)}}</td>
							<td v-show="showRow(columnsDetail, 6)" v-if="props.row.edit">
								<app-input-text
									class="edit-inline"
									model="amountSeat"
									:text="props.row.amount | round "
									:value="props.row.amount | round "
									@change="changeAmountSeat({ row:props.row, value:$event, index: props.index })"
								></app-input-text>
								</td>
								<td v-show="showRow(columnsDetail, 6)" v-else>
									{{props.row.amount ? props.row.amount : 0}}
								</td>
							<td v-show="showRow(columnsDetail, 7)">{{ props.row.costCenter && props.row.costCenter.name ? props.row.costCenter.name : null }}
							</td>
							<td v-show="showRow(columnsDetail, 8)">
								<button
									v-if="props.row.edit"
									class="btn-edit-detail"
									type="button"
									tabindex="6"
									@click="saveSeat(props.row, props.index)"
								>
									Guardar
								</button>
								<app-tooltip-button
									v-else
									color="success"
									:disabled="model.square === 1"
									img="/static/img/actions-list/edit.svg"
									text="Editar"
									:width="16"
									@click-icon="editSeats(props.index)"
								/>
							</td>
						</template>
					</app-table>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogAction"
			max-width="400"
		>
			<v-card>
				<v-card-text class="title text-xs-center pt-4">¿ Desea contabilizar los registros ?</v-card-text>
				<v-card-text class="titleNumberSeat text-xs-center pt-1">Nº de Asientos a contabilizar:  {{ this.dataSelected.length === 0 ? 1 : this.dataSelected.length }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						@click="closeDialogAction"
						type="button"
						color="error"
						class="btn-action mr-1 white--text">
						NO
					</v-btn>
					<v-btn
						@click="postRecord"
						type="button"
						color="success"
						class="btn-action ml-1 white--text">
						SI
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogWait"
			max-width="400"
			persistent
		>
			<v-card class="text-card">
				<v-card-text>
					<div class="loading-icon">
						<div class="spinner"></div>
						<p class="title text-xs-center pt-4" >Espere un momento, se estan creando los asientos.</p>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			content-class="confirmation-dialog"
			v-model="cancelModal"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">¿Desea eliminar los asientos seleccionados?</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						:disabled="flagWait"
						type="button"
						class="btn-modal cancelSeat mr-2"
						@click="setId">
						No
					</button>
					<button
						:disabled="flagWait"
						type="button"
						class="btn-modal save ml-2"
						@click="onDeleteSeat">
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<action-bar
			:value-disabled="valuesDisabled"
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		></action-bar>
		<v-dialog
		content-class="confirmation-dialog"
		v-model="dialogDeleteAccounting"
		max-width="400">
			<v-card>
				<v-card-text class="title text-xs-center pt-4">{{ titleDialogDelete }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn cancel"
						@click="closeDialogAccouting"
					>
						No
					</button>
					<button
						type="button"
						class="btn agree"
					>
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
	<!--<section class="modal-filter-footer">
		<modal-sidebar-button
			:is-loading="disabledConfirm"
			success-text="Confirmar"
			@accept-button-clicked="saveAccouting"
		></modal-sidebar-button>
	</section> -->
  </div>
</template>

<script>
import appInputText from '@/components/autocomplete/app-input-text';
import { mapGetters } from 'vuex';
import actionBar from '@/components/shared/action-bar/action-bar';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appDateSelect from '@/components/shared/app-date-select';
import BaseSelect from '@/components/shared/inputs/base-select';
import backButtonRoute from '@/components/shared/back-button-route';
import { format, subDays } from 'date-fns';
import dateComponent from '@/components/autocomplete/date-component';
import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
import lib from '@/shared/lib';

const { getDeeper } = lib;

function created() {
	this.loadModules();
	this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.model.endDate = this.$today;
	window.addEventListener('resize', this.reziseMobile);
	this.model.status = 3;
	this.model.accountingSeat = 0;
	if (this.model.accountingSeat === 0) {
		this.flagStateRecord = false;
	}
	this.reziseMobile();
	this.loadAccounts();
}

async function loadModules() {
	const params = { subsidiaryId: this.subsidiaryId };
	({ data: this.modules } = await this.$http.get('type-register', { params }));
	if (this.modules.length === 1) {
		this.model.moduleId = this.modules[0].id;
	}
	this.modulesFilter = this.modules;
}

function setModule(value) {
	this.model.moduleId = value;
	this.titleModule = `REGISTROS DE MÓDULO ${this.model.moduleId}`;
	this.titleModuleSeat = `ASIENTOS CREADOS MÓDULO  ${this.model.moduleId}`;
	const index = this.modules.findIndex(m => m.code === value);
	if (index > -1) {
		this.valuesShow = this.modules[index].templateJson || {};
	}
}
async function setStatusRecords(value) {
	this.model.accountingSeat = value;
	this.flagStateRecord = false;
}
async function setStatus(value) {
	this.model.status = value;
	await this.loadAccountingDetail.call(this);
	this.selectedAllSeat();
}
async function setTypes(value) {
	this.model.square = value;
	if (this.model.square === 2) {
		this.flagNoConfirm = true;
	} else {
		this.flagNoConfirm = false;
	}
	await this.loadAccountingDetail.call(this);
	this.selectedAllSeat();
}

async function onPage(page) {
	this.currentPageDetail = page;
	await this.loadAccountingDetail.call(this);
}


async function loadAccountingDetail() {
	const params = {
		subsidiaryId: this.$route.params.subsidiaryId,
		status: this.model.status,
		moduleCode: this.model.moduleId,
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		square: this.model.square,
		page: this.currentPageDetail,
		limit: 100,
	};
	try {
		const response = await this.$http.get('accounting-seats', { params });
		this.lastPageDetails = Number(response.headers['x-last-page']);
		this.itemsTotalQuantityDetails = Number(response.headers['x-quantity']);
		this.rowsSeat = response.data.map((row) => {
			const newRow = { ...row };
			newRow.isSelected = false;
			return newRow;
		});
	} catch (error) {
		this.showGenericError();
	} finally {
		const activeFlagPage = true;
		this.dialogLoading = false;
		this.loadAccounting(activeFlagPage);
	}
}

async function loadAccounting(flagPage) {
	const flagActivePage = flagPage;
	if (this.model.moduleId !== 'Contabilidad') {
		if (this.model.moduleId === 'VENTA') {
			this.model.moduleId = 1;
		}
		if (this.model.moduleId === 'COMPRA') {
			this.model.moduleId = 2;
		}
		if (this.model.moduleId === 'CTAXPAG') {
			this.model.moduleId = 3;
		}
		if (this.model.moduleId === 'CTAXCOB') {
			this.model.moduleId = 4;
		}
		if (this.model.moduleId === 'INGRESOS') {
			this.model.moduleId = 6;
		}
		if (this.model.moduleId === 'EGRESOS') {
			this.model.moduleId = 7;
		}
		if (this.model.moduleId === 'CAJA') {
			this.model.moduleId = 8;
		}
		if (this.model.moduleId === 'BANCO') {
			this.model.moduleId = 9;
		}

		this.dialogLoading = true;
		const params = {
			accountingSeat: this.model.accountingSeat,
			startDate: this.model.startDate,
			endDate: this.model.endDate,
			search: this.model.search,
			subsidiaryId: this.subsidiaryId || this.currentSubsidiary.id,
			page: flagActivePage ? 1 : this.currentPage,
			limit: 100,
			flagForNull: this.model.moduleId === 1 || this.model.moduleId === 2 ? 1 : null,
		};
		try {
			const response = await this.$http.get(`registers/accounting-seat/${this.model.moduleId}?&sortField=created_at`, { params });
			this.itemsTotalQuantity = Number(response.headers['x-quantity']);
			this.rows = response.data.map((row) => {
				const newRow = { ...row };
				newRow.isSelected = false;
				const flag = Object.keys(this.valuesShow).length;
				const searchDate = flag ? this.valuesShow.date.split('.') : null;
				const searchEntity = flag ? this.valuesShow.entity.split('.') : null;
				const searchReference = flag ? this.valuesShow.reference.split('.') : null;
				const searchAmount = flag ? this.valuesShow.amount.split('.') : null;
				newRow.dateToShow = searchDate ? getDeeper(...searchDate)(row) : null;
				newRow.entityToShow = searchEntity ? getDeeper(...searchEntity)(row) : null;
				newRow.referenceToShow = searchReference ? getDeeper(...searchReference)(row) : null;
				newRow.amountToShow = searchAmount ? getDeeper(...searchAmount)(row) : null;
				return newRow;
			});
			this.lastPage = Number(response.headers['x-last-page']);
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			} else if (error.status === 400) {
				if (error.data.message === 'SUBSIDIARY_NOT_CONFIG_FILTERS') {
					this.showGenericError('Empresa sin configuración de integración a Firebase');
				}
			}
		} finally {
			this.dialogLoading = false;
			if (this.model.moduleId === 1) {
				this.model.moduleId = 'VENTA';
			}
			if (this.model.moduleId === 2) {
				this.model.moduleId = 'COMPRA';
			}
			if (this.model.moduleId === 3) {
				this.model.moduleId = 'CTAXPAG';
			}
			if (this.model.moduleId === 4) {
				this.model.moduleId = 'CTAXCOB';
			}
			if (this.model.moduleId === 6) {
				this.model.moduleId = 'INGRESOS';
			}
			if (this.model.moduleId === 7) {
				this.model.moduleId = 'EGRESOS';
			}
			if (this.model.moduleId === 8) {
				this.model.moduleId = 'CAJA';
			}
			if (this.model.moduleId === 9) {
				this.model.moduleId = 'BANCO';
			}
		}
	}
}

function rowIsSelected({ id, isSelected }) {
	this.checkAll = this.rows.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelected.push(this.rows.find(row => row.id === id));
	} else {
		const index = this.dataSelected.findIndex(row => row.id === id);
		this.dataSelected.splice(index, 1);
	}
}

function clearAccouting() {
	this.model.moduleId = null;
	this.showAccouting = false;
	this.valuesShow = {};
}

function onSearch(value) {
	this.model.search = value || null;
	this.loadAccounting();
}

function selectedAll(checked) {
	this.checkAll = checked;
	this.rows = this.rows.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelected = this.rows.filter(r => r.isSelected);
}
function selectedAllSeat(checked) {
	this.checkAllAccounting = checked;
	this.rowsSeat = this.rowsSeat.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelectedAccounting = this.rowsSeat.filter(r => r.isSelected);
}


function openDetail(row) {
	this.dialogDetailAccounting = true;
	this.nameAccouting = `${row.code} - ${row.gloss}`;
	this.rowsDetailModal = row.details.map((det) => {
		const newDet = { ...det };
		newDet.edit = false;
		return newDet;
	});
}

function changePage(page) {
	this.currentPage = page;
	this.model.page = page;
	this.loadAccounting();
	this.dataSelected = [];
}

function statusColor({ status }) {
	return status === 1 ? 'success' : 'error';
}

function statusName({ status }) {
	return status === 1 ? 'Correcto' : 'Pendiente';
}

async function saveAccouting() {
	const body = {
		ids: this.dataSelectedAccounting.map(accounting => accounting.id),
	};
	try {
		await this.$http.patch('accounting-seat/confirm', body);
		this.showNotification('Los asientos fueron asignados correctamente');
		this.loadAccountingDetail();
		this.loadAccounting();
		this.dataSelectedAccounting = [];
	} catch (error) {
		this.showGenericError();
	} finally {
		this.selectedAllSeat();
	}
}

function rowIsSelectedAccounting({ id, isSelected }) {
	this.checkAllAccounting = this.rowsSeat.every(row => row.isSelected);
	if (isSelected) {
		this.dataSelectedAccounting.push(this.rowsSeat.find(row => row.id === id));
	} else {
		const index = this.dataSelectedAccounting.findIndex(row => row.id === id);
		this.dataSelectedAccounting.splice(index, 1);
	}
}

function closeDialog() {
	this.nameAccouting = null;
	this.dialogDetailAccounting = false;
}

function getType({ amount }) {
	return amount < 0 ? 'H' : 'D';
}

function getDate({ value, model }) {
	this.model[model] = format(value, 'YYYY-MM-DD');
}

function disabledConfirm() {
	return !this.dataSelectedAccounting.length > 0;
}

async function postRecord() {
	if (this.model.moduleId === 1) {
		this.model.moduleId = 'VENTA';
	}
	if (this.model.moduleId === 2) {
		this.model.moduleId = 'COMPRA';
	}
	if (this.model.moduleId === 3) {
		this.model.moduleId = 'CTAXPAG';
	}
	if (this.model.moduleId === 4) {
		this.model.moduleId = 'CTAXCOB';
	}
	if (this.model.moduleId === 6) {
		this.model.moduleId = 'INGRESOS';
	}
	if (this.model.moduleId === 7) {
		this.model.moduleId = 'EGRESOS';
	}
	if (this.model.moduleId === 8) {
		this.model.moduleId = 'CAJA';
	}
	if (this.model.moduleId === 9) {
		this.model.moduleId = 'BANCO';
	}
	const body = {
		ruc: this.currentSubsidiary.documentNumber,
		documents: this.dataSelected.map(p => p.id),
	};
	const subsidiaryId = this.$route.params.subsidiaryId;
	try {
		this.dialogAction = false;
		this.dialogWait = true;
		await this.$http.post(`accounting-seat/${this.model.moduleId}/multiple?subsidiaryId=${subsidiaryId}`, body);
		this.showNotification('Los registros se guardaron correctamente.');
		this.dialogWait = false;
		this.closeDialogAction();
		this.loadAccountingDetail();
		this.dataSelected = [];
	} catch (error) {
		this.dialogWait = false;
		this.showGenericError();
	} finally {
		this.selectedAll();
	}
}

function closeDialogAction() {
	this.dialogAction = false;
}

function runAction({ codeWeb }) {
	if (codeWeb === 'post-record') {
		this.dialogAction = true;
	} else {
		this.rowsIds = this.rowsSeat.filter(i => i.isSelected === true).map(row => row.id);
		this.rowIdsModules = this.rowsSeat.filter(i => i.isSelected === true).map(row => ({
			id: row.id,
			moduleName: row.typeRegister.code,
			gloss: row.gloss,
		}));
		this.cancelModal = true;
	}
}

function valuesDisabled() {
	if (this.dataSelected.length < 1) {
		return [
			{ code: 'post-record', disabled: true },
		];
	}
	return [];
}

function getDataDate(val) {
	if (val === 1) {
		this.model.startDate = this.$today;
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = true;
	}
}

function loadCont() {
	this.dataSelected = [];
	this.rowsSeat = [];
	this.rows = [];
	this.dialogLoading = true;
	this.showAccouting = true;
	this.loadAccountingDetail();
	this.selectedAllSeat();
	this.selectedAll();
}

function openDialogDelete() {
	this.titleDialogDelete = '¿Está seguro que desea eliminar el asiento?';
	this.dialogDeleteAccounting = true;
}

function closeDialogAccouting() {
	this.dialogDeleteAccounting = false;
}

function goToEditAccouting() {
	const routeData = this.$router.resolve({ name: 'page-edit-accounting',
		params: { subsidiaryId: this.$route.params.subsidiaryId, moduleId: this.model.moduleId } });
	window.open(routeData.href, '_blank');
}
function setId() {
	this.cancelModal = false;
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}
async function onDeleteSeat() {
	try {
		// Usamos map en lugar de forEach para obtener un array de promesas
		this.flagWait = true;
		const promises = this.rowIdsModules.map(async (item) => {
			const { id, moduleName, gloss } = item;
			if (moduleName === 'CAJA' || moduleName === 'BANCO') {
				const numberDocument = gloss.match(/\d+/)[0];
				this.documentNumberUpdate = numberDocument;
			}
			const payload = {
				moduleCode: moduleName,
			};

			const response = moduleName === 'COMPRA'
				? await this.$http.patch(`accounting-seat-cancel/${id}?flagCancel=${this.flagCancel}`, payload)
				: await this.$http.patch(`accounting-seat-cancel/${id}`, payload);

			if (response.status === 200) {
				if (moduleName === 'CAJA' || moduleName === 'BANCO') {
					await this.$http.patch(`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`, { ids:	[id] });
				}
			}
		});
		// Esperar a que todas las promesas se resuelvan antes de continuar
		await Promise.all(promises);
	} catch (error) {
		this.showGenericError();
	} finally {
		// Llamar a onDeleteSeatMultiple después de que todas las llamadas se completen
		this.onDeleteSeatMultiple();
		this.selectedAllSeat();
	}
}
async function onDeleteSeatMultiple() {
	const ids = { ids: this.rowsIds };
	try {
		await this.$http.delete('accounting-seat', { data: ids });
		this.showNotification('La eliminación ha sido realizada correctamente.');
		this.closeModal();
		this.params.subsidiaryId = this.subsidiaryId || null;
		if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		} else {
			this.dataSelected = [];
			this.rowsSeat = [];
			this.rowIdsModules = [];
			this.rowsIds = [];
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		await this.loadAccountingDetail.call(this);
		this.setId();
		this.flagWait = false;
	}
}
function openMobileAccouting() {
	this.openMobile = !this.openMobile;
}

function closeMobile() {
	this.detailJournalOpen = false;
	this.openMobile = false;
}

function editSeats(index) {
	this.rowsDetailModal[index].edit = true;
}

function changeAmountSeat(item) {
	const { row, value, index } = item;
	if (row.type === 1) {
		this.rowsDetailModal[index].amount = value < 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountDebe = value < 0 ? Number(value * -1) : Number(value);
	} else {
		this.rowsDetailModal[index].amount = value > 0 ? Number(value) * -1 : Number(value);
		this.rowsDetailModal[index].amountHaber = value < 0 ? Number(value) * -1 : Number(value);
	}
}

async function saveSeat(row, index) {
	try {
		this.rowsDetailModal[index].edit = false;
		const body = {
			account: row.accountingAccount.code,
			accountingAccountId: row.accountingAccount.id,
			amount: row.amount,
			concept: row.concept,
			costCenterId: row.costCenterId,
			reference: row.reference,
		};
		await this.$http.patch(
			`accounting-seat-details/${row.accountingSeatId}/${row.id}`,
			body,
		);
		this.loadAccountingDetail();
		this.showNotification('Asiento contable actualizado correctamente');
	} catch (error) {
		this.showGenericError();
	}
}
async function loadAccounts() {
	const params = {
		status: 1,
	};
	({ data: this.accounts } = await this.$http.get(
		`accounting-plan/${this.subsidiaryId}/subsidiary`, { params }));
}
function changeAccount(item) {
	const { value, index } = item;
	this.rowsDetailModal[index].accountingAccount = value;
	this.rowsDetailModal[index].accountingAccountId = value.id;
	this.rowsDetailModal[index].account = value.code;
}


function data() {
	return {
		deleteTooltip: 'Eliminar Asiento',
		currentPage: 1,
		accounts: [],
		flagNoConfirm: false,
		currentPageDetail: 1,
		flagWait: false,
		rowsIds: [],
		rowIdsModules: [],
		checkAllAccounting: false,
		checkAll: false,
		columns: [
			{ id: 1, name: 'F. de Crea.', tooltip: 'Fecha de Creación', value: 'account', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Numero de documento: ', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Concepto: ', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Monto', checked: true, visible: true, movil: true },
		],
		columnsSeat: [
			{ id: 1, name: 'Asiento', value: 'code', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
			{ id: 3, name: 'Fecha', value: 'date', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Estado', checked: true, visible: true, movil: true },
			{ id: 5, name: 'Debe', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Haber', checked: true, visible: true, movil: true },
			{ id: 7, name: 'Acción', checked: true, visible: true, movil: true },
		],
		columnsDetail: [
			{ id: 1, name: 'Cód. Cta.', value: 'code', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Cuenta Cta.', value: 'code', checked: true, visible: true, movil: true },
			{ id: 3, name: 'Referencia', value: 'code', checked: true, visible: true },
			{ id: 4, name: 'Concepto de mov', value: 'code', checked: true, visible: true, movil: true },
			{ id: 5, name: 'Tipo', value: 'code', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Importe', value: 'code', checked: true, visible: true, movil: true },
			{ id: 7, name: 'Centro de costo', value: 'code', checked: true, visible: true },
			{ id: 8, name: 'acciones', value: 'actions', checked: true, visible: true },
		],
		dialogLoading: false,
		itemsTotalQuantity: null,
		itemsTotalQuantityDetails: null,
		dialogDetailAccounting: false,
		dialogAction: false,
		dialogWait: false,
		flagDate: false,
		dataSelectedAccounting: [],
		dataSelected: [],
		dialogDeleteAccounting: false,
		listAccounting: true,
		lastPage: 0,
		lastPageDetails: 0,
		modules: [],
		model: {
			limit: 20,
			search: null,
			moduleId: null,
			stateId: 'pending',
			startDate: null,
			endDate: null,
			onSearch: null,
			status: null,
			accountingSeat: null,
			square: 1,
		},
		mobile: false,
		nameAccouting: null,
		flagCancel: true,
		cancelModal: false,
		showDetailAccounting: false,
		rowsDetails: [],
		rowsDetailModal: [],
		rows: [],
		rowsSeat: [],
		showAccouting: false,
		openMobile: false,
		titleDialogDelete: '',
		flagStateRecord: true,
		titleModule: '',
		titleModuleSeat: '',
		valuesShow: {},
		modulesFilter: [],
		status: [
			{ id: 2, name: 'Anulados' },
			{ id: 3, name: 'Pendientes' },
			{ id: 1, name: 'Contabilizados' },
		],
		statusRecords: [
			{ id: 0, name: 'Sin asiento' },
			// { id: 1, name: 'Con asiento' },
		],
		typesModule: [
			{ id: 1, name: 'Cuadrados' },
			{ id: 2, name: 'No Cuadrados' },
		],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
	};
}

export default {
	name: 'page-accounting-action',
	created,
	data,
	destroyed,
	components: {
		actionBar,
		appTooltipButton,
		appDateSelect,
		dateComponent,
		autocompleteComponent,
		BaseSelect,
		backButtonRoute,
		appInputText,
	},
	computed: {
		disabledConfirm,
		valuesDisabled,
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
	},
	methods: {
		changePage,
		setTypes,
		getDataDate,
		onPage,
		closeDialog,
		clearAccouting,
		loadAccounts,
		setId,
		closeDialogAction,
		onDeleteSeat,
		onDeleteSeatMultiple,
		closeDialogAccouting,
		closeMobile,
		getDate,
		getType,
		loadAccounting,
		loadCont,
		loadModules,
		loadAccountingDetail,
		statusColor,
		setModule,
		setStatus,
		setStatusRecords,
		openDialogDelete,
		openDetail,
		onSearch,
		rowIsSelected,
		rowIsSelectedAccounting,
		runAction,
		saveAccouting,
		statusName,
		selectedAll,
		selectedAllSeat,
		postRecord,
		goToEditAccouting,
		reziseMobile,
		changeAccount,
		openMobileAccouting,
		editSeats,
		saveSeat,
		changeAmountSeat,
	},
};
</script>

<style lang="scss" scoped>
.btn-accounting {
	border-radius: 24px !important;
	box-shadow: none !important;
	color: white !important;
	font-family: map-get($fonts, AvenirRegular) !important;
	font-size: 12px !important;
	font-weight: 600;
	text-transform: capitalize !important;
	width: 80px;

	@media (max-width: 1024px) {
		width: 100%;
	}
}
.btnSaveAccounting {
	color: white !important;
}
#column-6 {
	span {
		color: red !important;
	}
}
.titleNumberSeat {
	color: #02979b !important;
	font-family: "Avenir Regular", Arial, sans-serif;
	font-weight: bold;
}
.loading-search {
	color: white !important;
	font-family: map-get($fonts, AvenirDemi) !important;
	font-size: 14px !important;
	text-align: center;
}
.btn-modal {
	border-radius: 30px;
	color: map-get($colors, white);
	height: 30px;
	padding: 0px 20px;
	width: 93px;
}
.content-dialog {
	box-shadow: none !important;
}

.blue-debe {
	color: #006edb;
	font-family: map-get($fonts, AvenirBold);
	font-size: 11px;
}
.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}
.red-haber {
	color: #ff0000;
	font-family: map-get($fonts, AvenirBold);
	font-size: 11px;
}

.btn {
	border-radius: 30px;
	color: white;
	height: 30px;
	padding: 0 10px;
	width: 90px;
}

.agree {
	background-color: color(secondary);
	margin-left: 10px;
}

.cancel {
	background-color: color(error);
	margin-right: 10px;
}
.cancelSeat {
	background-color: color(error);
}
.save {
	background-color: color(secondary);
}


.show-mobile {
	@media (max-width: 890px) {
		padding: 8px !important;
	}
}

.row-mobile {
	@media (min-width: 1024px) {
		padding: 0 24px;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/8;
		grid-row: 2;
		white-space: nowrap;
	}
}

.reference {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}

.entity {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.content-acc {
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all .2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
			width: 100%;
		}
	}
}

.loading-icon {
	display: inline-flex;
	align-items: center;
}

// .dialog-container {
// 	background-color: #f9f9f9;
// 	border: 1px solid #ccc;
// 	border-radius: 8px;
// 	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
// 	display: none;
// 	flex-direction: column;
// 	align-items: center;
// }

.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #3D989B;
    border-radius: 100%;
    width: 60px;
    height: 40px;
	margin: 20px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

.titleWait {
	font-family: "Avenir Regular", Arial, sans-serif;
	font-size: 20px;
	font-weight: bold;
	display: inline-block;
	margin: 0;

}
.text-card {
	border-radius: 10px;
	background-color: #e6e2e2;
}

.btn-edit-detail {
	background-color: color(secondary);
	border-radius: 10px;
	color: color(white);
	font-family: font(AvenirBold);
	font-size: size(small11);
	padding: 2px 4px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-accouting-action.vue